<template>
  <BaseModal
    :value="true"
    :modal-title="$t('workflow.status.question.deleteChamp')"
    @click:outside="close"
    @keydown.esc="close"
    @close="close"
  >
    <template #modal>
      <div class="text-center">
        <BaseParagraph v-text="$t('workflow.operation.deleteMessage')" />
      </div>
    </template>
    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="close"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton color="secondary" type="primary" @click="submit">
        {{ $t("utils.delete") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import { Operation } from "@/core/Models/Operation";
import workflowApi from "../Services/workflow.api";

export default {
  name: "OperationDeleteDialog",
  props: {
    selectedOperation: {
      type: Operation,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async submit() {
      try {
        await workflowApi.deleteOrganizationWorkflowOperations(
          this.$route.params.organizationId,
          this.$route.params.workflowId,
          this.selectedOperation.id
        );
        this.$store.dispatch("snackbar/active", {
          message: this.$t("workflow.operation.deletedOperation"),
          type: "SUCCESS",
        });
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.$emit("operation-deleted");
      this.$emit("close");
    },
  },
};
</script>
